import {useMutation, useQueryClient} from 'react-query';
import PostPesticideAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostPesticideAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostPesticideAdvertisement = ({
  onSuccess,
}: IPostPesticideAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPesticideAdvertisementPayload) => {
      return PostPesticideAdvertisement(payload);
    },
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostPesticideAdvertisement};
